import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Loadable from "react-loadable";
import MediaQuery from "react-responsive";
import { Helmet } from "react-helmet";

import { getCategoryList, queryStringCategory, loadCategory } from "../../actions";
import Modal from "../Modals";
import { AsynLoader } from "../Loader/AsynLoader";
import { queryString, generateQueryStringFromReduxState } from "../../utils";
import Input from "../FormComponents/Input";

class Categories extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryLink: props.query.category || "anything",
      categoryName: "Any Category",
      showModal: false,
      redirect: "",
      mount: false,
      categorySearch: "",
      categories: []
    };
  }
  componentWillUnmount() {
    window.removeEventListener("mousedown", this.detectClickOutSide);
  }

  componentDidMount() {
    window.addEventListener("mousedown", this.detectClickOutSide);
    const { location } = this.props.query;
    let locationId = 0;
    if (location.category !== "State" && location.id) {
      locationId = location.id;
    }
    this.props.getCategoryList(locationId);
    const data = JSON.parse(window.__FIRST_CATEGORIES);
    const categories = data.categories;
    this.setState({ categories });
    this.props.loadCategory(categories);
  }

  componentDidUpdate(prevProps) {
    if (this.props.categories !== prevProps.categories || this.props.query !== prevProps.query) {
      if (this.state.mount) {
        const { type, location } = this.props.query;
        if (location !== prevProps.query.location) {
          this.props.getCategoryList(location.id);
        }
        if (this.props.categories) {
          const categoryNameArray = this.props.categories.filter(category => category.link === type);

          let categoryName = "Any Category";
          if (categoryNameArray.length > 0) {
            categoryName = categoryNameArray[0].name;
          }
          this.setState({
            categoryLink: type && type !== "" ? type : "anything",
            categoryName: categoryName
          });
        }
      } else {
        this.setState({ mount: true });
      }
    }
  }

  handleSelect = (link, name) => {
    if (link === "anything") {
      this.handleReset();
    } else {
      let q = generateQueryStringFromReduxState(this.props.query);
      q.type = link;
      this.setState({
        categoryLink: link,
        categoryName: name,
        showModal: false,
        redirect: "/activity?" + queryString.stringify(q)
      });
      this.props.queryStringCategory(link, name);
    }
  };

  handleReset = () => {
    let q = generateQueryStringFromReduxState(this.props.query);
    delete q.type;

    this.setState({
      categoryLink: "anything",
      categoryName: "Any Category",
      showModal: false,
      redirect: "/activity?" + queryString.stringify(q)
    });

    this.props.queryStringCategory("", "");
  };

  detectClickOutSide = e => {
    if (window.innerWidth > 700) {
      if (!this.categoryList.contains(e.target)) {
        this.setState({ showModal: false });
      }
    }
  };

  handleCategorySearch = e => {
    const searchStr = e.target.value;
    let categories = [];
    if (searchStr === "") {
      categories = this.props.categories;
    } else {
      const re = new RegExp(`${searchStr}.*`, "i");
      categories = this.props.categories.filter(category => re.test(category.name));
    }
    this.setState({ categorySearch: e.target.value, categories });
  };
  render() {
    const { location } = this.props.query;
    // let categories = this.props.categories;
    let { categories } = this.state;
    if (categories.length > 0 && categories[0].link !== "anything")
      categories.unshift({ link: "anything", name: "Any Category" });
    return (
      <div className="filter__categories" ref={node => (this.categoryList = node)}>
        {this.state.categoryName !== "Any Category" && (
          <Helmet>
            <title>
              {location.id && location.name !== ""
                ? `${this.state.categoryName} in ${location.name} - Trodly`
                : `${this.state.categoryName} Activities - Trodly`}
            </title>
            <meta
              name="description"
              content={
                location.id && location.name !== ""
                  ? `Book amazing travel activities and discover the best packages in ${this.state.categoryName} in ${
                      location.name
                    }. Find best price on tours and unique experiences with Trodly.`
                  : `Book amazing travel activities and discover the best packages in ${
                      this.state.categoryName
                    }. Find best price on tours and unique experiences with Trodly.`
              }
            />
          </Helmet>
        )}
        {this.state.redirect !== "" && <Redirect to={this.state.redirect} />}
        <div
          className="filter__categories__containers"
          onClick={() => this.setState(prev => ({ showModal: !prev.showModal }))}>
          <span className="filter__categories__icon__name_container">
            <span className="filter__categories__icon" />
            <span className="filter__categories__selected_category">{this.state.categoryName}</span>
          </span>
          <MediaQuery minWidth={700}>
            <span className={`dropdown__icon ${this.state.showModal ? "open" : ""}`} />
          </MediaQuery>
        </div>
        {this.state.showModal && (
          <MediaQuery maxWidth={700}>
            {matches => {
              if (matches) {
                return (
                  <Modal close={() => this.setState({ showModal: false })} reset={this.handleReset}>
                    <AsynCategoryList
                      categories={categories}
                      selected={this.state.categoryLink}
                      handleSelect={this.handleSelect}
                    />
                  </Modal>
                );
              } else {
                return (
                  <ul className="dropdown__list">
                    <li className="item">
                      <Input
                        type="text"
                        placeholder="Search category"
                        autoFocus={true}
                        autoComplete="off"
                        onChange={this.handleCategorySearch}
                        value={this.state.categorySearch}
                      />
                    </li>
                    {categories &&
                      categories.map(category => (
                        <li
                          key={category.link}
                          className="item"
                          onClick={() => this.handleSelect(category.link, category.name)}>
                          {category.name}
                        </li>
                      ))}
                  </ul>
                );
              }
            }}
          </MediaQuery>
        )}
      </div>
    );
  }
}

const AsynCategoryList = Loadable({
  loader: () => import("../Modals/Categories.jsx"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader,
  delay: 0
});
const mapStateToProps = state => {
  return {
    categories: state.category,
    query: state.queryString
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getCategoryList: locationId => dispatch(getCategoryList(locationId)),
    queryStringCategory: (category, name) => dispatch(queryStringCategory(category, name)),
    loadCategory: categories => dispatch(loadCategory(categories))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Categories);
